import { Button, FormField, Input, SpaceBetween } from "@amzn/awsui-components-react";
import { FC, useState } from "react";
import { MapEngineHandle } from "../../react";

export interface ZoomToXYPanelProps {
    handle: MapEngineHandle | null;
}

const inRange = (n: number, min: number, max: number) => !Number.isNaN(n) && n >= min && n <= max;

/**
 * Navigate to a lng/lat at a chosen zoom. Ported from 1.0 ZoomToLocation,
 * using the v2 engine's flyTo. Validates ranges before enabling Navigate.
 */
const ZoomToXYPanel: FC<ZoomToXYPanelProps> = ({ handle }) => {
    const [lng, setLng] = useState("-122.3394");
    const [lat, setLat] = useState("47.6077");
    const [zoom, setZoom] = useState("10");

    const lngN = parseFloat(lng);
    const latN = parseFloat(lat);
    const zoomN = parseFloat(zoom);
    const valid = inRange(lngN, -180, 180) && inRange(latN, -90, 90) && inRange(zoomN, 0, 24);

    const navigate = () => {
        if (!valid) return;
        handle?.engine()?.flyTo({ lng: lngN, lat: latN, zoom: zoomN, animate: false });
    };

    return (
        <SpaceBetween size="s">
            <FormField label="Longitude" description="-180 to 180">
                <Input value={lng} onChange={({ detail }) => setLng(detail.value)} />
            </FormField>
            <FormField label="Latitude" description="-90 to 90">
                <Input value={lat} onChange={({ detail }) => setLat(detail.value)} />
            </FormField>
            <FormField label="Zoom" description="0 to 24">
                <Input type="number" value={zoom} onChange={({ detail }) => setZoom(detail.value)} />
            </FormField>
            <Button variant="primary" disabled={!valid} onClick={navigate}>
                Navigate
            </Button>
        </SpaceBetween>
    );
};

export default ZoomToXYPanel;
